import {PhoneNumber} from "@/components/phone/PhoneNumber.tsx";

interface ListCellProps {
  items: string[];
  id: string;
  phoneNumber?: boolean;
}

export const ListCell = ({items, id, phoneNumber}: ListCellProps) => (
  <div className="text-break pulse-color-gray-700">
    {items.map((item, idx) => (
      <div key={`${id}-${idx}`}>{phoneNumber ? <PhoneNumber value={item} /> : item}</div>
    ))}
  </div>
);
